import * as React from 'react';

import {Radio, Table} from 'antd';

import {FileType, ICourseMaterial} from '../../model/CourseMaterial';
import Firebase, {withFirebase} from '../../components/Firebase';
import {gaMaterialTypeClicked, gaOpenFileClicked} from '../../ga/course';

const columns = [
  {
    title: 'File name', key: 'fileName',
    render: (material: ICourseMaterial) => {
      return <span>
        {material.fileName}
      </span>
    }
  },
  {
    title: 'Info', key: 'info',
    render: (material: ICourseMaterial) => {
      return <span>
        {material.semester} {material.year}
      </span>
    }
  },
  {
    title: '', key: 'actions',
    render: (material: ICourseMaterial) => {
      gaOpenFileClicked();
      return <a href={material.downloadUrl} target='_blank' style={{cursor: 'pointer'}}> Open </a>
    }
  }
];

interface IProps {
  firebase: Firebase;
  courseSlug: string;
}

interface IState {
  fileType: FileType,
  materials: ICourseMaterial[],
  loading: boolean
}

class Materials extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      fileType: FileType.syllabus,
      materials: [],
      loading: false

    };
  }

  componentDidMount(): void {
    this.getMaterials(this.state.fileType);
  }

  getMaterials = (fileType: FileType) => {
    this.setState({loading: true});
    this.props.firebase.getMaterials(fileType, this.props.courseSlug)
      .then((materials: ICourseMaterial[]) => {
        this.setState(() => ({materials, loading: false}));
      })
      .catch((err) => {
        // console.log(err);
      })
  };

  handleMaterialsChange = (e: any) => {
    const fileType = e.target.value;
    gaMaterialTypeClicked(fileType);

    this.setState({fileType});
    this.getMaterials(fileType);
  }

  public render() {
    const {materials, loading} = this.state;
    return(
      <div>
        <div className='materials-filters'>
          <Radio.Group size='small' value={this.state.fileType} onChange={this.handleMaterialsChange}>
            <Radio.Button value={FileType.syllabus}>Syllabus</Radio.Button>
            <Radio.Button value={FileType.assignment}>Assignment</Radio.Button>
            <Radio.Button value={FileType.quiz}>Quiz</Radio.Button>
            <Radio.Button value={FileType.midterm}>Midterm</Radio.Button>
            <Radio.Button value={FileType.final}>Final</Radio.Button>
          </Radio.Group>
        </div>

        <Table columns={columns}
               loading={loading}
               dataSource={materials} />

      </div>
    )
  }

}


export default withFirebase(Materials);